//
//
//
//
//
//
//
//
//

import adminSection from '~/mixins/admin-section'

export default {
  name: 'AdminSectionContent',
  mixins: [adminSection]
}
